import { APP_SAGA_LOGOUT,APP_SAGA_SET_APP_ERROR, APP_SAGA_SET_LOADING } from '../actionTypes'

export const loading = toggle => ({ type: APP_SAGA_SET_LOADING, loading: toggle })
export const logout = () => ({ type: APP_SAGA_LOGOUT })
export const setAppError = error => ({ type: APP_SAGA_SET_APP_ERROR, error })
